export const MOCK_CONTRACT_DETAILS = {
  entity: {
    contract_name: 'Max Spark Dynamic Green+',
    contract_number: '589010218',
    account_number: '',
    move_in_date: '2025-05-01',
    type: 'recurring',
    installment_amount: 20000,
    installment_amount_currency: 'EUR',
    installment_amount_decimal: '200.00',
    balance: 0,
    balance_currency: 'EUR',
    balance_decimal: '0.00',
    _schema: 'contract',
    _id: '78d3639c-ef63-4517-9942-3407dda87de7',
    _org: 'test-org',
    _created_at: '2025-05-07T07:58:32.296Z',
    _updated_at: '2025-06-17T11:03:27.608Z',
    status: 'active',
    billing_period: 'monthly',
    billing_duration_unit: 'months',
    notice_time_unit: 'months',
    termination_time_unit: 'months',
    renewal_duration_unit: 'months',
    _title: 'Max Spark Dynamic Green+',
    meters: {
      $relation: [
        {
          entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
          _tags: []
        }
      ]
    },
    customer: {
      $relation: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _schema: 'contact',
          _tags: []
        }
      ]
    },
    line_items: [
      {
        price_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
        product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
        quantity: 1,
        description: 'Dynamic Green+',
        unit_amount: 0,
        unit_amount_decimal: '0.00',
        pricing_model: 'per_unit',
        item_components: [
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Grundpreis',
            unit_amount: 0,
            unit_amount_decimal: '1.3e-9',
            pricing_model: 'tiered_volume',
            _price: {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            tiers_details: [
              {
                quantity: 0,
                unit_amount: 0,
                unit_amount_decimal: '0',
                unit_amount_net: 0,
                unit_amount_gross: 0,
                amount_subtotal: 0,
                amount_total: 0,
                amount_tax: 0
              }
            ],
            unit_amount_gross: 0,
            unit_amount_net: 0,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0',
            unit_amount_gross_decimal: '0',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          },
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Energie Spotmarktpreis',
            unit_amount: 24,
            unit_amount_decimal: '0.243801',
            pricing_model: 'dynamic_tariff',
            _price: {
              _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Energie Spotmarktpreis',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'dynamic_tariff',
              renewal_duration_unit: 'months',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: true,
              billing_period: 'monthly',
              dynamic_tariff: {
                interval: 'hourly',
                markup: 0,
                markup_amount: 15,
                markup_amount_decimal: '0.1511',
                markup_decimal: '0.00',
                mode: 'day_ahead_market'
              },
              internal_description: 'Energie Spotmarktpreis',
              _title: 'Energie Spotmarktpreis',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_net: 20,
            unit_amount_gross: 24,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            dynamic_tariff: {
              interval: 'hourly',
              markup: 0,
              markup_amount: 15,
              markup_amount_decimal: '0.1511',
              markup_decimal: '0.00',
              mode: 'day_ahead_market',
              markup_amount_net: 13,
              markup_amount_gross: 15,
              unit_amount_net: 8,
              unit_amount_gross: 9,
              unit_amount_net_decimal: '0.0779',
              unit_amount_gross_decimal: '0.092701',
              markup_amount_net_decimal: '0.126974789916',
              markup_amount_gross_decimal: '0.1511'
            },
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0.204874789916',
            unit_amount_gross_decimal: '0.243801',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          },
          {
            price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
            product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            quantity: 1,
            description: 'Umlagen, Abgaben, Steuern, etc.',
            unit_amount: 16,
            unit_amount_decimal: '0.1611',
            pricing_model: 'per_unit',
            _price: {
              _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Umlagen, Abgaben, Steuern, etc.',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 16,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.1611',
              variable_price: true,
              billing_period: 'monthly',
              internal_description: 'Umlagen, Abgaben, Steuern, etc.',
              _title: 'Umlagen, Abgaben, Steuern, etc.',
              averageMarketPrice: {
                market: 'day_ahead',
                bidding_zone: 'DE-LU',
                price: {
                  timestamp:
                    '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                  unit_amount: 7.79,
                  unit_amount_decimal: '0.0779',
                  unit_amount_currency: 'EUR'
                },
                _meta: {
                  timestamp: 1747981644144,
                  signature:
                    'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                },
                inputs: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  from: '2025-04-01',
                  to: '2025-04-30'
                }
              }
            },
            _product: {
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom', 'dont-touch'],
              active: true,
              categories: [],
              description: 'Außerhalb der Grundversorgung',
              feature: [
                {
                  _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                  _tags: [],
                  feature: '100% Ökostrom',
                  value: ''
                },
                {
                  _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                  _tags: [],
                  feature: 'Erstlaufzeit bis 31.12.2025',
                  value: ''
                },
                {
                  _id: 'SbRtgtY6flxvlR1M-LaHi',
                  _tags: [],
                  feature: 'Kündigungsfrist 1 Monat',
                  value: ''
                },
                {
                  _id: 'v07rw_RfinlcUOfQD0h9S',
                  _tags: [],
                  feature:
                    '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                  value: ''
                }
              ],
              internal_name: 'Strom Green+',
              name: 'Strom Green+',
              price_options: [
                {
                  _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  description: 'Classic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: null,
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: null,
                  tiers: [],
                  type: null,
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: null,
                  billing_duration_amount: null,
                  billing_duration_unit: null,
                  billing_period: null,
                  internal_description: 'Classic Green+',
                  notice_time_amount: null,
                  notice_time_unit: null,
                  renewal_duration_amount: null,
                  renewal_duration_unit: null,
                  termination_time_amount: null,
                  termination_time_unit: null,
                  unit: null,
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.709Z',
                  _updated_at: '2025-05-23T06:23:55.130Z',
                  _title: 'Classic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                  }
                },
                {
                  _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                  _schema: 'price',
                  _tags: ['Commodity', 'Strom'],
                  active: true,
                  billing_duration_unit: 'months',
                  description: 'Dynamic Green+',
                  is_composite_price: true,
                  is_tax_inclusive: true,
                  notice_time_unit: 'months',
                  price_components: [],
                  price_display_in_journeys: 'show_price',
                  pricing_model: 'per_unit',
                  renewal_duration_unit: 'months',
                  termination_time_unit: 'months',
                  tiers: [],
                  type: 'one_time',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  variable_price: false,
                  billing_period: 'weekly',
                  internal_description: 'Dynamic Green+',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:27.918Z',
                  _updated_at: '2025-05-23T06:24:15.056Z',
                  _title: 'Dynamic Green+',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                  }
                }
              ],
              product_downloads: [
                {
                  _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Datenschutz'],
                      _title: 'Datenschutzinformationen.pdf',
                      access_control: 'public-read',
                      filename: 'Datenschutzinformationen.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.522Z',
                  _updated_at: '2025-04-04T07:57:21.022Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                  $relation: {
                    entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                  }
                },
                {
                  _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'AGB'],
                      _title: 'AGB.pdf',
                      access_control: 'public-read',
                      filename: 'AGB.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.247Z',
                  _updated_at: '2025-04-04T07:57:21.704Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                  $relation: {
                    entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                  }
                },
                {
                  _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Widerrufsformular'],
                      _title: 'Muster-Widerrufsformular.pdf',
                      access_control: 'public-read',
                      filename: 'Muster-Widerrufsformular.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:21.101Z',
                  _updated_at: '2025-04-04T07:57:21.569Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                  $relation: {
                    entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                  }
                },
                {
                  _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  },
                  versions: [
                    {
                      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                      _purpose: [],
                      _tags: ['Commodity', 'Preisblatt'],
                      _title: 'Preisblatt.pdf',
                      access_control: 'public-read',
                      filename: 'Preisblatt.pdf',
                      mime_type: 'application/pdf',
                      type: 'document',
                      category: 'unknown',
                      file_entity_id: '',
                      size_bytes: 11451,
                      readable_size: '11.18 KB',
                      public_url:
                        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                      s3ref: {
                        bucket: 'epilot-prod-user-content',
                        key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                      }
                    }
                  ],
                  _schema: 'file',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:57:20.386Z',
                  _updated_at: '2025-04-04T07:57:20.823Z',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  source_url:
                    'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                  $relation: {
                    entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                  }
                }
              ],
              product_images: [],
              type: 'product',
              _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              _title: 'Strom Green+',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: 'test-org',
                  _owners: [
                    {
                      org_id: 'test-org',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_net: 14,
            unit_amount_gross: 16,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0.135378151261',
            unit_amount_gross_decimal: '0.1611',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0'
          }
        ],
        _price: {
          _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
          _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
          _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
          _tags: ['Commodity', 'Strom'],
          active: true,
          billing_duration_unit: 'months',
          description: 'Dynamic Green+',
          is_composite_price: true,
          is_tax_inclusive: true,
          notice_time_unit: 'months',
          price_components: [
            {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis'
            },
            {
              _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Energie Spotmarktpreis',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'dynamic_tariff',
              renewal_duration_unit: 'months',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: true,
              billing_period: 'monthly',
              dynamic_tariff: {
                interval: 'hourly',
                markup: 0,
                markup_amount: 15,
                markup_amount_decimal: '0.1511',
                markup_decimal: '0.00',
                mode: 'day_ahead_market'
              },
              internal_description: 'Energie Spotmarktpreis',
              _title: 'Energie Spotmarktpreis'
            },
            {
              _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Umlagen, Abgaben, Steuern, etc.',
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              termination_time_unit: 'months',
              tiers: [],
              type: 'recurring',
              unit: 'kwh',
              unit_amount: 16,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.1611',
              variable_price: true,
              billing_period: 'monthly',
              internal_description: 'Umlagen, Abgaben, Steuern, etc.',
              _title: 'Umlagen, Abgaben, Steuern, etc.'
            }
          ],
          price_display_in_journeys: 'show_price',
          pricing_model: 'per_unit',
          renewal_duration_unit: 'months',
          termination_time_unit: 'months',
          tiers: [],
          type: 'one_time',
          unit_amount: 0,
          unit_amount_currency: 'EUR',
          unit_amount_decimal: '0.00',
          variable_price: false,
          billing_period: 'weekly',
          internal_description: 'Dynamic Green+',
          _title: 'Dynamic Green+'
        },
        _product: {
          _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
          _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
          _tags: ['Commodity', 'Strom', 'dont-touch'],
          active: true,
          categories: [],
          description: 'Außerhalb der Grundversorgung',
          feature: [
            {
              _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
              _tags: [],
              feature: '100% Ökostrom',
              value: ''
            },
            {
              _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
              _tags: [],
              feature: 'Erstlaufzeit bis 31.12.2025',
              value: ''
            },
            {
              _id: 'SbRtgtY6flxvlR1M-LaHi',
              _tags: [],
              feature: 'Kündigungsfrist 1 Monat',
              value: ''
            },
            {
              _id: 'v07rw_RfinlcUOfQD0h9S',
              _tags: [],
              feature:
                '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
              value: ''
            }
          ],
          internal_name: 'Strom Green+',
          name: 'Strom Green+',
          price_options: [
            {
              _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _schema: 'price',
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Classic Green+',
              is_composite_price: true,
              is_tax_inclusive: null,
              price_components: [],
              price_display_in_journeys: 'show_price',
              pricing_model: null,
              tiers: [],
              type: null,
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: null,
              billing_duration_amount: null,
              billing_duration_unit: null,
              billing_period: null,
              internal_description: 'Classic Green+',
              notice_time_amount: null,
              notice_time_unit: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              unit: null,
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:27.709Z',
              _updated_at: '2025-05-23T06:23:55.130Z',
              _title: 'Classic Green+',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              $relation: {
                entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
              }
            },
            {
              _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _schema: 'price',
              _tags: ['Commodity', 'Strom'],
              active: true,
              billing_duration_unit: 'months',
              description: 'Dynamic Green+',
              is_composite_price: true,
              is_tax_inclusive: true,
              notice_time_unit: 'months',
              price_components: [],
              price_display_in_journeys: 'show_price',
              pricing_model: 'per_unit',
              renewal_duration_unit: 'months',
              termination_time_unit: 'months',
              tiers: [],
              type: 'one_time',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              variable_price: false,
              billing_period: 'weekly',
              internal_description: 'Dynamic Green+',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:27.918Z',
              _updated_at: '2025-05-23T06:24:15.056Z',
              _title: 'Dynamic Green+',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              $relation: {
                entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
              }
            }
          ],
          product_downloads: [
            {
              _id: '26495f53-c961-4214-a417-9a7b05e039a1',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Datenschutz'],
              _title: 'Datenschutzinformationen.pdf',
              access_control: 'public-read',
              filename: 'Datenschutzinformationen.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Datenschutz'],
                  _title: 'Datenschutzinformationen.pdf',
                  access_control: 'public-read',
                  filename: 'Datenschutzinformationen.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:20.522Z',
              _updated_at: '2025-04-04T07:57:21.022Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
              $relation: {
                entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
              }
            },
            {
              _id: '570756ec-796f-41b7-981c-e731ef4905ef',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'AGB'],
              _title: 'AGB.pdf',
              access_control: 'public-read',
              filename: 'AGB.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'AGB'],
                  _title: 'AGB.pdf',
                  access_control: 'public-read',
                  filename: 'AGB.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:21.247Z',
              _updated_at: '2025-04-04T07:57:21.704Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
              $relation: {
                entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
              }
            },
            {
              _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Widerrufsformular'],
              _title: 'Muster-Widerrufsformular.pdf',
              access_control: 'public-read',
              filename: 'Muster-Widerrufsformular.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Widerrufsformular'],
                  _title: 'Muster-Widerrufsformular.pdf',
                  access_control: 'public-read',
                  filename: 'Muster-Widerrufsformular.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:21.101Z',
              _updated_at: '2025-04-04T07:57:21.569Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
              $relation: {
                entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
              }
            },
            {
              _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
              _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
              _purpose: [],
              _tags: ['Commodity', 'Preisblatt'],
              _title: 'Preisblatt.pdf',
              access_control: 'public-read',
              filename: 'Preisblatt.pdf',
              mime_type: 'application/pdf',
              type: 'document',
              category: 'unknown',
              file_entity_id: '',
              size_bytes: 11451,
              readable_size: '11.18 KB',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
              },
              versions: [
                {
                  _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                  _purpose: [],
                  _tags: ['Commodity', 'Preisblatt'],
                  _title: 'Preisblatt.pdf',
                  access_control: 'public-read',
                  filename: 'Preisblatt.pdf',
                  mime_type: 'application/pdf',
                  type: 'document',
                  category: 'unknown',
                  file_entity_id: '',
                  size_bytes: 11451,
                  readable_size: '11.18 KB',
                  public_url:
                    'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                  s3ref: {
                    bucket: 'epilot-prod-user-content',
                    key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                  }
                }
              ],
              _schema: 'file',
              _org: 'test-org',
              _owners: [
                {
                  org_id: 'test-org',
                  user_id: '140034'
                }
              ],
              _created_at: '2025-04-04T07:57:20.386Z',
              _updated_at: '2025-04-04T07:57:20.823Z',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              source_url:
                'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
              $relation: {
                entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
              }
            }
          ],
          product_images: [],
          type: 'product',
          _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
          _title: 'Strom Green+',
          _messages: {}
        },
        external_price_metadata: {
          market: 'day_ahead',
          bidding_zone: 'DE-LU',
          price: {
            timestamp:
              '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
            unit_amount: 7.79,
            unit_amount_decimal: '0.0779',
            unit_amount_currency: 'EUR'
          },
          _meta: {
            timestamp: 1747981644144,
            signature:
              'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
          },
          inputs: {
            market: 'day_ahead',
            bidding_zone: 'DE-LU',
            from: '2025-04-01',
            to: '2025-04-30'
          }
        },
        external_fees_mappings: [
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            amount_total: 7.79,
            amount_total_decimal: '0.0779'
          }
        ],
        price_mappings: [
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            value: 0
          },
          {
            price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
            value: 0
          },
          {
            price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
            value: 0
          }
        ],
        currency: 'EUR',
        amount_subtotal: 0,
        amount_total: 0,
        total_details: {
          amount_tax: 0,
          breakdown: {
            taxes: [
              {
                tax: {
                  _id: '170d696a-611a-4627-a904-137741027989',
                  type: 'VAT',
                  rate: '19'
                },
                amount: 0
              }
            ],
            recurrences: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                unit_amount_gross: 40,
                amount_subtotal: 0,
                amount_total: 0,
                amount_subtotal_decimal: '0',
                amount_total_decimal: '0',
                amount_tax: 0
              }
            ],
            recurrencesByTax: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                amount_total: 0,
                amount_subtotal: 0,
                amount_tax: 0,
                tax: {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 0
                }
              }
            ],
            cashbacks: []
          }
        },
        amount_tax: 0,
        amount_subtotal_decimal: '0',
        amount_total_decimal: '0'
      }
    ],
    amount_subtotal: 0,
    amount_total: 0,
    total_details: {
      amount_tax: 0,
      breakdown: {
        taxes: [
          {
            tax: {
              _id: '170d696a-611a-4627-a904-137741027989',
              type: 'VAT',
              rate: '19'
            },
            amount: 0
          }
        ],
        recurrences: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_gross: 40,
            amount_subtotal: 0,
            amount_total: 0,
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0',
            amount_tax: 0
          }
        ],
        recurrencesByTax: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            amount_total: 0,
            amount_subtotal: 0,
            amount_tax: 0,
            tax: {
              tax: {
                _id: '170d696a-611a-4627-a904-137741027989',
                type: 'VAT',
                rate: '19'
              },
              amount: 0
            }
          }
        ],
        cashbacks: []
      }
    },
    currency: 'EUR',
    redeemed_promos: [],
    start_date: '2025-01-01',
    end_date: null,
    _tags: ['dont-touch'],
    amount_tax: 0,
    prices: {
      $relation: [
        {
          entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
          _schema: 'price',
          _tags: []
        }
      ]
    },
    products: {
      $relation: [
        {
          entity_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
          _schema: 'product',
          _tags: []
        }
      ]
    },
    notice_time_amount: '2',
    billing_address: {
      $relation_ref: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          path: 'address',
          _id: 'L6sB14Iori1DB0PodxizK'
        }
      ]
    },
    delivery_address: [
      {
        _id: '9RpwXqqpoKV9QkrJiJ7sV',
        _tags: [],
        street: 'Adolf-Fischer-Str.',
        zip: '',
        city: 'Köln',
        country: 'DE',
        additional_info: 'Penthouse',
        postal_code: '50670',
        street_number: '2'
      }
    ],
    payment: {
      $relation_ref: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          path: 'payment',
          _id: 'UvxxbZ13mCnwchDZxheL8'
        }
      ]
    }
  },
  orders: [],
  meters: [
    {
      _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
      meter_type: 'smart-meter',
      meter_number: '1ESY2158347841311',
      sector: 'power',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _org: 'test-org',
      _created_at: '2025-05-07T11:40:35.712Z',
      _title: '1ESY2158347841311',
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      _updated_at: '2025-05-23T06:18:09.077Z',
      obis_number: '2-3:6.8.9',
      direction: 'feed-in',
      tariff_type: 'et',
      unit: 'kWh',
      transformer_ratio: '1',
      counters: {
        $relation: [
          {
            entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
            _schema: 'meter_counter',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
          },
          {
            entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
          },
          {
            entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
          },
          {
            entity_id: '70550f17-7337-4514-9044-0962f000e949'
          },
          {
            entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
          }
        ]
      },
      ma_lo_id: 'DE228554800',
      used_for: 'Haushaltsstrom',
      manufacturer: 'EMH',
      calibration_date: '2025-01-01',
      location: 'Werkstatt',
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        ]
      },
      $relation: {
        entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
        _tags: [],
        attribute: 'meters'
      }
    },
    {
      ma_lo_id: 'DE852287503',
      meter_type: 'electronic-meter',
      tariff_type: 'et',
      meter_number: '1ESY6311780912661',
      sector: 'power',
      used_for: 'Haushaltsstrom',
      manufacturer: 'Sagemcom',
      calibration_date: '2025-01-01',
      location: 'Keller Oben Mitte',
      status: 'active',
      _tags: ['dont-touch'],
      _schema: 'meter',
      _id: 'e250a873-fe35-4b24-b502-19a84347200d',
      _org: 'test-org',
      _created_at: '2025-05-19T11:40:47.144Z',
      _title: '1ESY6311780912661',
      counters: {
        $relation: [
          {
            entity_id: 'c2dd7872-6ac0-4d7c-85a2-8f7775315832',
            _tags: []
          }
        ]
      },
      contract: {
        $relation: [
          {
            entity_id: 'a68e4801-979c-4fee-b43f-0dbacb06634e'
          },
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
            _schema: 'contact',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: 'a18a9f26-d973-48b6-9b1c-27341f0f17ff'
          }
        ]
      },
      _updated_at: '2025-06-17T11:03:26.779Z',
      $relation: {
        entity_id: 'e250a873-fe35-4b24-b502-19a84347200d',
        attribute: 'contract',
        reverse: true
      }
    }
  ],
  files: [],
  relations: [
    {
      _org: 'test-org',
      _schema: 'contact',
      last_name: 'Max',
      first_name: 'Anna',
      email: [
        {
          email: 'maxspark360@gmail.com',
          _id: 'HfAOh-AdruvBugA1FbjQf',
          id: 'q37xcz3'
        }
      ],
      payment: [
        {
          _tags: [],
          _id: 'UvxxbZ13mCnwchDZxheL8',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            start_date: '2025-01-01'
          },
          type: 'payment_sepa',
          id: 'eb4tss8'
        },
        {
          _tags: [],
          _id: 'xLMGLijTFmrQilKXlyKU8',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'frsd5ru'
        },
        {
          _tags: [],
          _id: 'Eo67TPiGhp7NhOtj6Nc5E',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'h1811tg'
        },
        {
          _tags: [],
          _id: '0vEXDJ9JySVANsfaY5wAe',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030'
          },
          type: 'payment_sepa',
          id: '1xu838y'
        }
      ],
      birthdate: '1982-09-01',
      address: [
        {
          country: 'DE',
          city: 'Köln',
          _tags: ['delivery', 'billing'],
          additional_info: 'Penthouse',
          street: 'Adolf-Fischer-Str.',
          street_number: '2',
          _id: 'L6sB14Iori1DB0PodxizK',
          postal_code: '50670',
          id: '4ci2bne'
        }
      ],
      phone: [
        {
          phone: '012341234123',
          _id: 'UAa6m3SewPKOWJJXTXC3G',
          id: 'ewodw6a'
        }
      ],
      _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
      _created_at: '2025-04-04T09:18:17.430Z',
      _title: 'Max Anna',
      consent_email_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: 'maxspark360@gmail.com',
            status: 'active'
          }
        ]
      },
      consent_sms_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_phone_call: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_print_marketing: {
        status: 'unknown',
        identifiers: [
          {
            identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            status: 'unknown'
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
          },
          {
            entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
          },
          {
            entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
          },
          {
            entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
          },
          {
            entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
          },
          {
            entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
          },
          {
            entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
          },
          {
            entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
          }
        ]
      },
      first_ecp_login: '2025-04-04T13:56:15.807Z',
      _pending_changes: {},
      journey_actions: [
        {
          journey_id: '66877380-0662-11f0-a9ca-4f3dc91aee12',
          action_label: {
            en: 'Move or Terminate Contract',
            de: 'Move or Terminate Contract'
          },
          slug: 'contract'
        },
        {
          journey_id: '62144be0-05a7-11f0-9864-af17fa9de986',
          action_label: {
            en: 'IBAN Change',
            de: 'IBAN Change'
          },
          slug: 'contract'
        },
        {
          journey_id: '597b10d0-25d3-11f0-a06f-fd52871531fc',
          action_label: {
            en: 'General Request',
            de: 'Allgemeine Anfrage'
          },
          slug: 'contract',
          rules: []
        }
      ],
      files: [
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156167,
          readable_size: '152.51 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156167,
              readable_size: '152.51 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
          _org: 'test-org',
          _created_at: '2025-04-07T07:16:36.872Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:16:38.668Z'
        },
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 153036,
          readable_size: '149.45 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 153036,
              readable_size: '149.45 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
          _org: 'test-org',
          _created_at: '2025-04-07T07:00:37.276Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:00:38.801Z'
        },
        {
          filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156303,
          readable_size: '152.64 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156303,
              readable_size: '152.64 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
          _org: 'test-org',
          _created_at: '2025-04-04T13:52:22.441Z',
          _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-04T13:52:24.321Z'
        }
      ],
      language: 'en',
      customer_number: '1234567880',
      salutation: 'Mr.',
      inbetriebnahme: false,
      _updated_at: '2025-06-12T06:03:13.192Z'
    },
    {
      meter_type: 'smart-meter',
      meter_number: '1ESY2158347841311',
      sector: 'power',
      status: 'active',
      _tags: [],
      _schema: 'meter',
      _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
      _org: 'test-org',
      _created_at: '2025-05-07T11:40:35.712Z',
      _title: '1ESY2158347841311',
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      _updated_at: '2025-05-23T06:18:09.077Z',
      obis_number: '2-3:6.8.9',
      direction: 'feed-in',
      tariff_type: 'et',
      unit: 'kWh',
      transformer_ratio: '1',
      counters: {
        $relation: [
          {
            entity_id: 'bde93dd0-bfa5-4fec-8f73-790707c889f5',
            _schema: 'meter_counter',
            _tags: []
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: '3bddb912-9549-4aa9-a4a4-f6ae4696226b'
          },
          {
            entity_id: '3182215d-01d7-49c7-aab2-a1cc5d2ced46'
          },
          {
            entity_id: '4a32f2cd-f847-41f4-b17b-c5c89e3dc78c'
          },
          {
            entity_id: '70550f17-7337-4514-9044-0962f000e949'
          },
          {
            entity_id: 'b075a5c7-9484-4b10-893d-9a7dbb2a636b'
          }
        ]
      },
      ma_lo_id: 'DE228554800',
      used_for: 'Haushaltsstrom',
      manufacturer: 'EMH',
      calibration_date: '2025-01-01',
      location: 'Werkstatt',
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        ]
      }
    },
    {
      _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
      _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
      _schema: 'product',
      _tags: ['Commodity', 'Strom', 'dont-touch'],
      active: true,
      categories: [],
      description: 'Außerhalb der Grundversorgung',
      feature: [
        {
          _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
          _tags: [],
          feature: '100% Ökostrom',
          value: ''
        },
        {
          _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
          _tags: [],
          feature: 'Erstlaufzeit bis 31.12.2025',
          value: ''
        },
        {
          _id: 'SbRtgtY6flxvlR1M-LaHi',
          _tags: [],
          feature: 'Kündigungsfrist 1 Monat',
          value: ''
        },
        {
          _id: 'v07rw_RfinlcUOfQD0h9S',
          _tags: [],
          feature:
            '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
          value: ''
        }
      ],
      internal_name: 'Strom Green+',
      name: 'Strom Green+',
      price_options: {
        $relation: [
          {
            entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
          },
          {
            entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
          }
        ]
      },
      product_downloads: {
        $relation: [
          {
            entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
          },
          {
            entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
          },
          {
            entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
          },
          {
            entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
          }
        ]
      },
      product_images: {
        $relation: []
      },
      type: 'product',
      _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
      _org: 'test-org',
      _created_at: '2025-04-04T07:57:28.791Z',
      _updated_at: '2025-05-23T06:20:58.349Z',
      _title: 'Strom Green+'
    }
  ],
  workflow: [],
  journey_actions: [
    {
      journey_id: '66877380-0662-11f0-a9ca-4f3dc91aee12',
      action_label: {
        en: 'Move or Terminate Contract',
        de: 'Move or Terminate Contract'
      },
      slug: 'contract'
    },
    {
      journey_id: '62144be0-05a7-11f0-9864-af17fa9de986',
      action_label: {
        en: 'IBAN Change',
        de: 'IBAN Change'
      },
      slug: 'contract'
    },
    {
      journey_id: '597b10d0-25d3-11f0-a06f-fd52871531fc',
      action_label: {
        en: 'General Request',
        de: 'Allgemeine Anfrage'
      },
      slug: 'contract',
      rules: []
    }
  ]
}
